<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <app-system-settings />
      <special-invoice-configuration />
    </a-card>
  </page-header-wrapper>
</template>
<script>
import AppSystemSettings from './modules/AppSystemSettings'
import SpecialInvoiceConfiguration from './modules/SpecialInvoiceConfiguration'
export default {
  name: 'AppParameterSettings',
  components: { AppSystemSettings, SpecialInvoiceConfiguration }
}
</script>
